/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_GLOBAL_CATEGORIES_REQUEST =
  "FETCH_GLOBAL_CATEGORIES_REQUEST";
export const FETCH_GLOBAL_CATEGORIES_SUCCESS =
  "FETCH_GLOBAL_CATEGORIES_SUCCESS";
export const FETCH_GLOBAL_CATEGORIES_FAILURE =
  "FETCH_GLOBAL_CATEGORIES_FAILURE";
export const COMMON_ERROR = "COMMON_ERROR";
